import { TagColorType } from "components/DesignSystem/Tag/Tag";
import { TemplateTypes } from "types/Models/broadcast";
import {
  BroadcastStatus,
  BulkCallCampaignStatus,
} from "types/Models/broadcastCall";

export const CUSTOM_MESSAGE = "custom_message";

export const BROADCAST_CHAT_TEMPLATE = "chat";
export const BROADCAST_WHATSAPP_TEMPLATE = "whatsapp";
export const BROADCAST_EMAIL_TEMPLATE = "email";
export const BROADCAST_IVR_TEMPLATE = "ivrCall";

export const BROADCAST_TEMPLATE_TYPE: Record<TemplateTypes, string> = {
  chat: "chat_template_variables",
  whatsapp: "whatsapp_template_variables",
  email: "email_template_variables",
  ivrCall: "ivr_call_template_variables",
} as const;

export const BULK_CALL_RECORD_STATUSES = {
  PENDING: "PENDING",
  CALLING: "CALLING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  BUSY: "BUSY",
  NO_ANSWER: "NO_ANSWER",
  CANCELLED: "CANCELLED",
} as const;

export const BULK_CALL_CAMPAIGN_STATUSES = {
  SCHEDULED: "SCHEDULED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
} as const;

export const BROADCAST_STATUSES = {
  COMPLETED: "COMPLETED",
  IN_PROGRESS: "IN_PROGRESS",
  FAILED: "FAILED",
} as const;

export const BROADCAST_TYPES = {
  CHAT: "chat",
  EMAIL: "email",
  WHATSAPP: "whatsapp",
  IVR: "ivr",
} as const;

export const BROADCAST_MEDIUM_OPTIONS = {
  CHAT: "Chat",
  EMAIL: "Email",
  WHATSAPP: "WhatsApp",
  IVR: "Ivr",
};

export const BROADCAST_VIA_DISPLAY = {
  [BROADCAST_CHAT_TEMPLATE]: "Chat",
  [BROADCAST_WHATSAPP_TEMPLATE]: "WhatsApp",
  [BROADCAST_EMAIL_TEMPLATE]: "Email",
  [BROADCAST_IVR_TEMPLATE]: "IVR Call",
};

export const BROADCAST_STATUS_COLORS: Record<BroadcastStatus, TagColorType> = {
  [BROADCAST_STATUSES.COMPLETED]: "green",
  [BROADCAST_STATUSES.IN_PROGRESS]: "orange",
  [BROADCAST_STATUSES.FAILED]: "red",
} as const;

export const BROADCAST_STATUSES_DISPLAY = {
  [BROADCAST_STATUSES.COMPLETED]: "Completed",
  [BROADCAST_STATUSES.IN_PROGRESS]: "In Progress",
  [BROADCAST_STATUSES.FAILED]: "Failed",
} as const;

export const IVR_STATUS_COLORS: Record<BulkCallCampaignStatus, TagColorType> = {
  [BULK_CALL_CAMPAIGN_STATUSES.SCHEDULED]: "blue",
  [BULK_CALL_CAMPAIGN_STATUSES.IN_PROGRESS]: "orange",
  [BULK_CALL_CAMPAIGN_STATUSES.COMPLETED]: "green",
  [BULK_CALL_CAMPAIGN_STATUSES.CANCELLED]: "red",
} as const;

export const IVR_STATUSES_DISPLAY = {
  [BULK_CALL_CAMPAIGN_STATUSES.SCHEDULED]: "Scheduled",
  [BULK_CALL_CAMPAIGN_STATUSES.IN_PROGRESS]: "In Progress",
  [BULK_CALL_CAMPAIGN_STATUSES.COMPLETED]: "Completed",
  [BULK_CALL_CAMPAIGN_STATUSES.CANCELLED]: "Cancelled",
} as const;
